import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { checkForErrors } from '../../utils';
import {
  ProStudioContext,
  ProStudioEvents,
  SelectedSolution,
} from '../prostudio.xstate.types';
import { GetBotByIdData } from '../prostudio.api-service.types';
import { tableStore } from '../../stores';

export const setSelectedSolution = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{
  selectedSolution: SelectedSolution;
  cb?: (path?: string) => void;
} | void> => {
  if (event.type !== 'selectBot') {
    return;
  }

  const { project, solutions } = ctx;
  const { name, cb } = event;

  const projectId = project?.id;

  const selectedSolutionBotId = solutions?.find(
    (solution) => solution.displayName === name
  )?.botSolutionId;

  const selectedSolutionId = solutions?.find(
    (solution) => solution.displayName === name
  )?.id;

  if (!selectedSolutionBotId || !selectedSolutionId) {
    throwErrorWithId('Selected solution ID is required');
    return;
  }

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  const botResponse = await urqlGql.getBotById({
    botId: selectedSolutionBotId,
    projectId,
  });

  checkForErrors(botResponse);

  const solutionData = botResponse.data?.getBotById?.data as
    | GetBotByIdData
    | undefined;

  if (!solutionData) {
    throwErrorWithId('Solution data is required');
    return;
  }

  const selectedSolution = {
    ...solutionData,
    uniqueId: selectedSolutionId,
    displayName: name,
  };

  tableStore.setErrors([]);

  return {
    selectedSolution,
    cb: cb ? () => cb(`/${projectId}/${selectedSolutionId}`) : undefined,
  };
};
